// CURATOR OFFERS
export const GET_CURATOR_OFFERS = "GET_CURATOR_OFFERS"
export const GET_CURATOR_OFFERS_SUCCESS = "GET_CURATOR_OFFERS_SUCCESS"
export const GET_CURATOR_OFFERS_FAIL = "GET_CURATOR_OFFERS_FAIL"
export const CLEAR_CURATOR_OFFERS = "CLEAR_CURATOR_OFFERS"

// OPERATION OFFERS
export const GET_OPERATION_OFFERS = "GET_OPERATION_OFFERS"
export const GET_OPERATION_OFFERS_SUCCESS = "GET_OPERATION_OFFERS_SUCCESS"
export const GET_OPERATION_OFFERS_FAIL = "GET_OPERATION_OFFERS_FAIL"
export const CLEAR_OPERATION_OFFERS = "CLEAR_OPERATION_OFFERS"

// APPROVER OFFERS
export const GET_APPROVER_OFFERS = "GET_APPROVER_OFFERS"
export const GET_APPROVER_OFFERS_SUCCESS = "GET_APPROVER_OFFERS_SUCCESS"
export const GET_APPROVER_OFFERS_FAIL = "GET_APPROVER_OFFERS_FAIL"
export const CLEAR_APPROVER_OFFERS = "CLEAR_APPROVER_OFFERS"

// PUBLISHED OFFERS
export const GET_PUBLISHED_OFFERS = "GET_PUBLISHED_OFFERS"
export const GET_PUBLISHED_OFFERS_SUCCESS = "GET_PUBLISHED_OFFERS_SUCCESS"
export const GET_PUBLISHED_OFFERS_FAIL = "GET_PUBLISHED_OFFERS_FAIL"
export const CLEAR_PUBLISHED_OFFERS = "CLEAR_PUBLISHED_OFFERS"

// MANAGE CURATOR OFFER
export const MANAGE_CURATOR_OFFER = "MANAGE_CURATOR_OFFER"
export const MANAGE_CURATOR_OFFER_SUCCESS = "MANAGE_CURATOR_OFFER_SUCCESS"
export const MANAGE_CURATOR_OFFER_FAIL = "MANAGE_CURATOR_OFFER_FAIL"

// MANAGE OPERATION OFFER
export const MANAGE_OPERATION_OFFER = "MANAGE_OPERATION_OFFER"
export const MANAGE_OPERATION_OFFER_SUCCESS = "MANAGE_OPERATION_OFFER_SUCCESS"
export const MANAGE_OPERATION_OFFER_FAIL = "MANAGE_OPERATION_OFFER_FAIL"

// MANAGE PUBLISHED OFFER
export const MANAGE_PUBLISHED_OFFER = "MANAGE_PUBLISHED_OFFER"
export const MANAGE_PUBLISHED_OFFER_SUCCESS = "MANAGE_PUBLISHED_OFFER_SUCCESS"
export const MANAGE_PUBLISHED_OFFER_FAIL = "MANAGE_PUBLISHED_OFFER_FAIL"

// ===== OFFER TAGS =====
export const GET_OFFER_TAGS = "GET_OFFER_TAGS"
export const GET_OFFER_TAGS_SUCCESS = "GET_OFFER_TAGS_SUCCESS"
export const GET_OFFER_TAGS_FAIL = "GET_OFFER_TAGS_FAIL"
export const MANAGE_OFFER_TAG = "MANAGE_OFFER_TAG"
export const MANAGE_OFFER_TAG_SUCCESS = "MANAGE_OFFER_TAG_SUCCESS"
export const MANAGE_OFFER_TAG_FAIL = "MANAGE_OFFER_TAG_FAIL"
export const CLEAR_OFFER_TAGS = "CLEAR_OFFER_TAGS"

// OFFER TAG DEFINITIONS
export const GET_OFFER_TAG_DEFINITIONS = "GET_OFFER_TAG_DEFINITIONS"
export const GET_OFFER_TAG_DEFINITIONS_SUCCESS = "GET_OFFER_TAG_DEFINITIONS_SUCCESS"
export const GET_OFFER_TAG_DEFINITIONS_FAIL = "GET_OFFER_TAG_DEFINITIONS_FAIL"
export const CLEAR_OFFER_TAG_DEFINITIONS = "CLEAR_OFFER_TAG_DEFINITIONS"

// OFFER INCLUSIONS
export const GET_OFFER_INCLUSIONS = "GET_OFFER_INCLUSIONS"
export const GET_OFFER_INCLUSIONS_SUCCESS = "GET_OFFER_INCLUSIONS_SUCCESS"
export const GET_OFFER_INCLUSIONS_FAIL = "GET_OFFER_INCLUSIONS_FAIL"
export const MANAGE_OFFER_INCLUSIONS = "MANAGE_OFFER_INCLUSIONS"
export const MANAGE_OFFER_INCLUSIONS_SUCCESS = "MANAGE_OFFER_INCLUSIONS_SUCCESS"
export const MANAGE_OFFER_INCLUSIONS_FAIL = "MANAGE_OFFER_INCLUSIONS_FAIL"
export const CLEAR_OFFER_INCLUSIONS = "CLEAR_OFFER_INCLUSIONS"
export const CLEAR_OFFER_INCLUSIONS_SUCCESS = "CLEAR_OFFER_INCLUSIONS_SUCCESS"

// OFFER EXCLUSIONS
export const GET_OFFER_EXCLUSIONS = "GET_OFFER_EXCLUSIONS"
export const GET_OFFER_EXCLUSIONS_SUCCESS = "GET_OFFER_EXCLUSIONS_SUCCESS"
export const GET_OFFER_EXCLUSIONS_FAIL = "GET_OFFER_EXCLUSIONS_FAIL"
export const MANAGE_OFFER_EXCLUSIONS = "MANAGE_OFFER_EXCLUSIONS"
export const MANAGE_OFFER_EXCLUSIONS_SUCCESS = "MANAGE_OFFER_EXCLUSIONS_SUCCESS"
export const MANAGE_OFFER_EXCLUSIONS_FAIL = "MANAGE_OFFER_EXCLUSIONS_FAIL"
export const CLEAR_OFFER_EXCLUSIONS = "CLEAR_OFFER_EXCLUSIONS"
export const CLEAR_OFFER_EXCLUSIONS_SUCCESS = "CLEAR_OFFER_EXCLUSIONS_SUCCESS"

// OFFER TERMS & CONDITIONS
export const GET_OFFER_TERMS_CONDITIONS = "GET_OFFER_TERMS_CONDITIONS"
export const GET_OFFER_TERMS_CONDITIONS_SUCCESS = "GET_OFFER_TERMS_CONDITIONS_SUCCESS"
export const GET_OFFER_TERMS_CONDITIONS_FAIL = "GET_OFFER_TERMS_CONDITIONS_FAIL"
export const MANAGE_OFFER_TERMS_CONDITIONS = "MANAGE_OFFER_TERMS_CONDITIONS"
export const MANAGE_OFFER_TERMS_CONDITIONS_SUCCESS = "MANAGE_OFFER_TERMS_CONDITIONS_SUCCESS"
export const MANAGE_OFFER_TERMS_CONDITIONS_FAIL = "MANAGE_OFFER_TERMS_CONDITIONS_FAIL"
export const CLEAR_OFFER_TERMS_CONDITIONS = "CLEAR_OFFER_TERMS_CONDITIONS"
export const CLEAR_OFFER_TERMS_CONDITIONS_SUCCESS = "CLEAR_OFFER_TERMS_CONDITIONS_SUCCESS"

// Local state management for inclusion form
export const ADD_INCLUSION_TO_FORM = "ADD_INCLUSION_TO_FORM"
export const UPDATE_INCLUSION_IN_FORM = "UPDATE_INCLUSION_IN_FORM"
export const REMOVE_INCLUSION_FROM_FORM = "REMOVE_INCLUSION_FROM_FORM"
export const CLEAR_INCLUSION_FORM = "CLEAR_INCLUSION_FORM"

// Local state management for exclusion form
export const ADD_EXCLUSION_TO_FORM = "ADD_EXCLUSION_TO_FORM"
export const UPDATE_EXCLUSION_IN_FORM = "UPDATE_EXCLUSION_IN_FORM"
export const REMOVE_EXCLUSION_FROM_FORM = "REMOVE_EXCLUSION_FROM_FORM"
export const CLEAR_EXCLUSION_FORM = "CLEAR_EXCLUSION_FORM"

// Local state management for terms form
export const ADD_TERM_TO_FORM = "ADD_TERM_TO_FORM"
export const UPDATE_TERM_IN_FORM = "UPDATE_TERM_IN_FORM"
export const REMOVE_TERM_FROM_FORM = "REMOVE_TERM_FROM_FORM"
export const CLEAR_TERM_FORM = "CLEAR_TERM_FORM"

// HISTORY OF OFFER STATES
export const GET_OFFER_STATE_HISTORY = "GET_OFFER_STATE_HISTORY"
export const GET_OFFER_STATE_HISTORY_SUCCESS = "GET_OFFER_STATE_HISTORY_SUCCESS"
export const GET_OFFER_STATE_HISTORY_FAIL = "GET_OFFER_STATE_HISTORY_FAIL"
export const CLEAR_OFFER_STATE_HISTORY = "CLEAR_OFFER_STATE_HISTORY"

// OFFER ACTIONS
export const POST_OFFER = "POST_OFFER"
export const POST_OFFER_SUCCESS = "POST_OFFER_SUCCESS"
export const POST_OFFER_FAIL = "POST_OFFER_FAIL"

export const REJECT_OFFER = "REJECT_OFFER"
export const REJECT_OFFER_SUCCESS = "REJECT_OFFER_SUCCESS"
export const REJECT_OFFER_FAIL = "REJECT_OFFER_FAIL"

export const PROCESS_OFFER = "PROCESS_OFFER"
export const PROCESS_OFFER_SUCCESS = "PROCESS_OFFER_SUCCESS"
export const PROCESS_OFFER_FAIL = "PROCESS_OFFER_FAIL"

export const PUBLISH_OFFER = "PUBLISH_OFFER"
export const PUBLISH_OFFER_SUCCESS = "PUBLISH_OFFER_SUCCESS"
export const PUBLISH_OFFER_FAIL = "PUBLISH_OFFER_FAIL"

export const DENY_OFFER = "DENY_OFFER"
export const DENY_OFFER_SUCCESS = "DENY_OFFER_SUCCESS"
export const DENY_OFFER_FAIL = "DENY_OFFER_FAIL"
